import {format, parse} from "date-fns";

/**
 * Хелпер преобразования одного формата даты в другой
 */
export const dateConvert = (value: string, convertFrom: string, convertTo: string) => {
    return format(parse(value, convertFrom, new Date()), convertTo);
}